<template>
  <ClientOnly>
    <Teleport to="body">
      <Transition name="modal">
        <div
          v-if="isOpen"
          class="fixed left-0 top-0 z-[1000] flex size-full flex-col items-center justify-center overflow-hidden overscroll-none"
          :class="$attrs.class"
        >
          <!-- eslint-disable-next-line vuejs-accessibility/click-events-have-key-events vuejs-accessibility/no-static-element-interactions -->
          <div
            class="absolute left-0 top-0 size-full bg-black/85 backdrop-blur-lg"
            @click="closeModal"
          />
          <button
            v-if="!title"
            class="absolute right-4 top-4 z-100 size-12 shrink-0 rounded-full bg-black-bis/60 p-1 text-white backdrop-blur hover:bg-black-bis/90"
            @click="closeModal"
          >
            <SpriteSymbol name="close" class="size-full" />
          </button>
          <slot name="content">
            <main
              class="modal-container relative z-10 mx-section-x overflow-hidden rounded bg-white shadow-xl"
            >
              <div v-if="title" class="px-4 tablet:px-6">
                <div
                  class="flex justify-between gap-4 border-b border-b-grey-lightest py-4 tablet:items-center tablet:gap-7 tablet:py-6"
                >
                  <div
                    class="text-balance text-size-5 font-bold leading-tight text-black tablet:text-size-4-5"
                  >
                    {{ title }}
                  </div>
                  <button
                    class="size-8 shrink-0 rounded-full p-1 hover:bg-white-ter"
                    @click="closeModal"
                  >
                    <SpriteSymbol name="close" class="size-full text-black" />
                  </button>
                </div>
              </div>
              <div
                :class="{
                  'p-4 tablet:p-6': title,
                }"
              >
                <div v-if="text" class="text-prose text-black">{{ text }}</div>
                <slot />
              </div>
            </main>
          </slot>
        </div>
      </Transition>
    </Teleport>
  </ClientOnly>
</template>

<script lang="ts" setup>
const props = defineProps<{
  modalId: string
  card?: boolean
  title?: string
  text?: string
}>()

const { activeModal, closeModal } = useModal()

const isOpen = computed(() => props.modalId === activeModal.value)
</script>

<style lang="postcss">
.modal-enter-active,
.modal-leave-active {
  @apply transition-all duration-300 ease-swing;

  .modal-container {
    @apply transition-all duration-300 ease-bounce;
  }
}

.modal-enter-from,
.modal-leave-to {
  opacity: 0;

  .modal-container {
    @apply translate-y-1/2 tablet:translate-y-9 tablet:scale-90;
  }
}

.modal-leave-from,
.modal-enter-to {
  opacity: 1;
}
</style>
